// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__wdCWD","label":"Labeled_label__vgCWU","divider":"Labeled_divider__2wqgx"};